import { Outlet, createRootRoute, useRouterState } from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from '@dss/design-system'
import { AuthProvider, useAuthWorkspaceKey } from '@dss/auth'
import { PrivateQueryWorkspace } from '@dss/portal-ui'
import { authConfig } from '../lib/authConfig'
import { queryClient } from '../lib/queryClient'
import { SessionExpiredModal } from '../features/session/SessionExpiredModal'

/**
 * Root route admin app:
 * - <ThemeProvider> — управляет data-theme на <html>, начальное значение из localStorage.
 * - <AuthProvider> — OIDC PKCE через @dss/auth (oidc-client-ts).
 * - <QueryClientProvider> — TanStack Query singleton.
 * - <SessionExpiredModal> — глобальный handler events «токен истёк» → forced re-login.
 *
 * Дочерние роуты рендерятся через <Outlet/>.
 */
export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  return (
    <ThemeProvider defaultTheme="auto">
      <QueryClientProvider client={queryClient}>
        <AuthProvider config={authConfig}>
          <WorkspaceRoutes />
          <SessionExpiredModal />
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  )
}

function WorkspaceRoutes() {
  const scope = useAuthWorkspaceKey()
  const pathname = useRouterState({ select: (state) => state.location.pathname })
  const path = pathname.replace(/^\/admin(?=\/|$)/, '') || '/'
  const isPublic = ['/login', '/logout', '/auth/callback'].includes(path)
    || path.startsWith('/welcome/')
  return isPublic ? <Outlet /> : <PrivateQueryWorkspace scope={scope}><Outlet /></PrivateQueryWorkspace>
}
